import { assignmentRowTitle } from '@app/pages/admin/orchestration-identity.util';
import {
  assignmentStateSeverity,
  TagSeverity,
} from '@app/pages/admin/orchestration-process-page/orchestration-process-page.util';
import {
  AssignmentProcessGroup,
  AssignmentProcessGroupEdge,
} from '@app/services/assignment-process-groups.service';

export interface AssignmentGroupEdgeView {
  id: string;
  createdAt: string;
  state: string;
  stateSeverity: TagSeverity;
  resultCount: number | null;
  error: string | null;
}

/** One process row: display name plus the oldest and newest runs. */
export interface AssignmentGroupRowView {
  processKey: string;
  displayTitle: string;
  assignmentCount: number;
  earliest: AssignmentGroupEdgeView;
  latest: AssignmentGroupEdgeView;
}

export function toAssignmentGroupRow(
  row: AssignmentProcessGroup,
  processes?: Array<{ key: string; displayName?: string }> | null,
): AssignmentGroupRowView {
  const processKey = row.processDefinitionKey?.trim() ?? '';
  return {
    processKey,
    displayTitle: assignmentRowTitle(null, processKey, processes),
    assignmentCount: row.assignmentCount ?? 0,
    earliest: toEdge(row.earliest),
    latest: toEdge(row.latest),
  };
}

function toEdge(edge: AssignmentProcessGroupEdge | null | undefined): AssignmentGroupEdgeView {
  const resultCount = edge?.resultCount;
  return {
    id: edge?.id ?? '',
    createdAt: edge?.createdAt ?? '',
    state: edge?.state ?? '',
    stateSeverity: assignmentStateSeverity(edge?.state),
    resultCount: typeof resultCount === 'number' ? resultCount : null,
    error: edge?.error?.trim() || null,
  };
}
